export enum Channel {
  /** 国内 */
  Internal = 1,
  /** 商业 */
  Business,
  /** 国际 */
  International,
  /** 旅游 */
  Travel,
  /** 娱乐 */
  Amusement,
  /** 时尚 */
  Fashion,
  /** 大片 */
  Movie,
  /** 精选 */
  Picked,
  /** 体育 */
  Sports,
  /** 漫画图表 */
  Cartoon,
  /** 汽车 */
  Car = 262,
  /** 档案 */
  Archive,
}

export const CannelDisplayNameMap = {
  [Channel.Internal]: '国内',
  [Channel.Business]: '商业',
  [Channel.International]: '国际',
  [Channel.Travel]: '旅游',
  [Channel.Amusement]: '娱乐',
  [Channel.Fashion]: '时尚',
  [Channel.Movie]: '大片',
  [Channel.Picked]: '精选',
  [Channel.Sports]: '体育',
  [Channel.Cartoon]: '漫画图表',
  [Channel.Car]: '汽车',
  [Channel.Archive]: '档案',
};

export const NAV = [
  {
    label: '编辑图片',
    key: 'edit',
    path: '/v2/editorial',
    subMenu: [
      {
        label: '国内',
        key: 'categoryId=1',
        path: '/v2/category?categoryId=1',
        target: '_blank',
      },
      {
        label: '国际',
        key: 'categoryId=3',
        path: '/v2/category?categoryId=3',
        target: '_blank',
      },
      {
        label: '体育',
        key: 'categoryId=9',
        path: '/v2/category?categoryId=9',
        target: '_blank',
      },
      {
        label: '娱乐',
        key: 'categoryId=5',
        path: '/v2/category?categoryId=5',
        target: '_blank',
      },
      {
        label: '商业',
        key: 'categoryId=2',
        path: '/v2/category?categoryId=2',
        target: '_blank',
      },
      {
        label: '时尚',
        key: 'categoryId=6',
        path: '/v2/category/fashion?categoryId=6',
        target: '_blank',
      },
      {
        label: '精选',
        key: 'categoryId=8',
        path: '/v2/category?categoryId=8',
        target: '_blank',
      },
      {
        label: '旅游',
        key: 'categoryId=4',
        path: '/v2/category?categoryId=4',
        target: '_blank',
      },
      {
        label: '档案',
        key: 'categoryId=263',
        path: '/v2/category?categoryId=263',
        target: '_blank',
      },
    ],
  },
  {
    label: '创意图片',
    key: 'creative',
    path: '/creative',
  },
  {
    label: '编辑视频',
    key: 'video',
    path: '/video-home',
  },
  {
    label: '增值服务',
    key: 'z',
    // path: 'https://open.tuchong.com/',
    subMenu: [
      {
        label: 'API',
        key: 'API',
        path: 'https://open.tuchong.com/',
        target: '_blank',
      },
      {
        label: '版权知识',
        key: 'release',
        path: 'https://topic.tuchong.com/magic/eco/runtime/release/61f4fb55dc0356033cd540b2?appType=tuchong',
        target: '_blank',
      },
    ],
  },
  {
    label: '热门专线',
    key: 'hot',
    subMenu: [
      {
        label: 'R线',
        key: 'r',
        path: '/topic?topicId=39287',
        target: '_blank',
      },
      {
        label: 'E线',
        key: '/topic?topicId=39288',
        path: '/topic?topicId=39288',
        target: '_blank',
      },
      {
        label: '百人万元',
        key: '/topic?topicId=6865',
        path: '/topic?topicId=6865',
        target: '_blank',
      },
      {
        label: '中超官方',
        key: '/topic?topicId=6933',
        path: '/topic?topicId=6933',
        target: '_blank',
      },
      {
        label: '时装周专线',
        key: '/category?categoryId=66',
        path: '/category?categoryId=66',
        target: '_blank',
      },
      {
        label: '欧美明星专线',
        key: '/topic?topicId=7141',
        path: '/topic?topicId=7141',
        target: '_blank',
      },
    ],
  },
  {
    label: '图虫创意',
    key: 'weili',
    path: 'https://stock.tuchong.com',
    target: '_blank',
  },
];

export const GMP_ID = {
  banner: 'e0afa799506870e9295ba81858066139',
  notification: '12195a3019acfa8c5069075b1cf89307',
};

export const SENTRY_DSN =
  'https://b8a769ae4f98dd54f2b3b37fff101a6b@sentry.ituchong.com/12';
